import type { ReactNode } from "react";

import { H } from "@/app/(public)/_components/marketing/hero/hero-tokens";
import "./feature-page.css";

/** Rich-text tag `<muted>` in headlines: same ink as the rest, a grey half reads badly (29.10.2026). */
export function headlinePart(chunks: ReactNode): ReactNode {
  return chunks;
}

export function FeatureSectionHeading(props: {
  readonly title: ReactNode;
  readonly sub?: string;
}): ReactNode {
  return (
    <div
      style={{
        textAlign: "center",
        maxWidth: 940,
        margin: "0 auto",
        padding: "0 20px",
      }}
    >
      <h2
        className="mkft-heading-h2"
        style={{
          fontFamily: H.display,
          lineHeight: 1.08,
          color: H.ink,
          margin: 0,
        }}
      >
        {props.title}
      </h2>
      {props.sub !== undefined ? (
        <p
          className="mkft-heading-sub"
          style={{
            margin: "16px auto 0",
            maxWidth: 620,
            lineHeight: 1.55,
            color: H.inkMute,
          }}
        >
          {props.sub}
        </p>
      ) : null}
    </div>
  );
}
